import { Box, Flex, Text } from '@chakra-ui/react';
import { BrowserView } from 'react-device-detect';
import { BrowserSidebar } from '../component/globalComponents/BrowserSidebar';
import { BrowserTopBar } from '../component/globalComponents/BrowserTopBar';
import { MobileViewPage } from '../component/globalComponents/MobileViewPage';

export const TermsConditions = () => {
    const renderContent = () => (
        <Flex className={'privacy-policy'}>
            <h1>Terms and Conditions</h1>
            <p>
                <b>Table of contents:</b>
            </p>
            <ul>
                <li>Acceptance of Terms</li>
                <li>Registration</li>
                <li>Use, Access, Term and Termination</li>
                <li>Your choices and controls</li>
                <li>Third-Party Services</li>
                <li>General Health Notice</li>
                <li>STREAMSIX Privacy and Cookie Policy</li>
                <li>STREAMSIX Community Standards</li>
                <li>The STREAMSIX Economy</li>
                <ul>
                    <li>Fees and Payment</li>
                    <li>STREAMSIX VIRTUAL CURRENCIES</li>
                </ul>
            </ul>
            <p>
                <b>STREAMSIX Terms of Use</b>
            </p>
            <p>
                <b>Updated on 8/15/2023</b>
            </p>
            <p>
                Welcome to STREAMSIX! We’re excited you’re here and want to make sure you understand
                the terms and conditions that apply when using our website, games and the STREAMSIX
                application.
            </p>
            <p>
                <br />
            </p>
            <p>
                This is a legal agreement. By downloading and using the STREAMSIX app including the
                associated STREAMSIX games and STREAMSIX web and mobile apps
                <span>  </span>(“Application”), you agree to comply with these Terms of Use
                (“Terms”), our Code of Conduct, Privacy Policy, and any other policies, rules, and
                guidelines that are relevant to the Application. These can be found on our website.
                These Terms apply to everyone using the Application. Please ensure that you are
                legally allowed to accept these Terms and that you are at least 18 years old. Thank
                you for your cooperation in maintaining a safe and enjoyable experience for all.{' '}
            </p>
            <p>
                <br />
            </p>
            <p>
                If you don't agree with these Terms, do not to use the Application. It's important
                to us that you feel comfortable and fully informed. If you choose not to be bound by
                these Terms and the applicable laws, discontinue the use of the Application right
                away.
            </p>
            <p>
                <br />
            </p>
            <p>
                We have the right to make changes to these Terms at any time, and your continued use
                of the Application after the changes will indicate your acceptance of the updated
                Terms. It is your responsibility to review these Terms regularly to stay informed
                about any revisions; these Terms are current to the date indicated at the top of
                this document (“Updated on”). If you disagree with the changes, you must stop using
                the Application.
            </p>
            <p>
                <br />
            </p>
            <p>
                <br />
            </p>
            <p>
                <b>Registration </b>
            </p>
            <p>
                To get started, you need to register an account with us, which is a quick and easy
                process
            </p>
            <p>
                During the registration, we ask you to provide all the necessary information
                requested. It's important to keep this information up to date, so please keep it
                updated it in a timely manner. You are allowed to register for only one account. By
                providing accurate information, you'll ensure a smooth experience. Inaccurate
                information, on the other hand, may result in denial of access to the Application
                and any associated rewards, in-game currency, or prizing (if applicable).
            </p>
            <p>
                <span>To create an account and enjoy STREAMSIX</span>, you confirm that you are at
                least 18 years old and fully capable of agreeing to the terms and conditions
                outlined here. If you've authorized a minor to use the Application, please be aware
                that you are fully responsible for their use, controlling their access, and
                addressing any misuse that may occur.
            </p>
            <p>
                Please be aware that you are solely responsible for any activity that occurs on your
                account. We trust you to prioritize the security of your account and password.
                Taking precautions to keep your information safe including maintaining a strong
                password that only you know
            </p>
            <p>
                We're here to support you throughout this process, so if you have any questions or
                need further assistance, please don't hesitate to reach out to{' '}
                <span>help@streamsix.com.</span>
            </p>
            <p>
                <br />
            </p>
            <p>
                <b>Use, Access, Term and Termination</b>
                <span></span>
            </p>
            <p>
                These Terms remains in effect until terminated. Certain provisions that are
                necessary to uphold even after termination will continue to apply. These include
                provisions related to license limitations, disclaimer of warranties, limitation of
                liability, indemnification, and ownership.
            </p>
            <p>
                You have the freedom to terminate these Terms at any time. Simply delete the
                Application from all your mobile devices and permanently remove any copies of the
                Application, your STREAMSIX account related documentation in your possession. This
                includes any Application that minors or clients installed on computers under your
                control. It's important to ensure complete removal.
            </p>
            <p>
                When using the Application, we ask that you comply with all applicable laws, rules,
                and regulations, including adherence to export control laws. It’s important to stay
                informed and follow legal requirements. This includes adhering to regulations
                regarding the use of mobile devices while operating a vehicle. Safety is important
                to us, and we want to ensure responsible usage.
            </p>
            <p>
                We reserve the right to deny, revoke, or disable access to the Application, or any
                part of it, at our sole discretion and without notice. This action may be taken with
                or without cause. In such cases, we may provide notice via email to the last email
                address you provided.
            </p>
            <p>
                To facilitate product support, development, improvement, and other services, we may
                utilize various analytic technologies. These technologies allow us to collect, use,
                store, and transmit technical and related information regarding your mobile device.
                This includes details such as MAC Address and/or unique device id or UDID, IP
                address, geolocation, device make and model, operating system, software and
                applications, as well as application usage data.
            </p>
            <p>
                Please note that STREAMSIX operates in various countries. When you submit personal
                information through the Application, it may be transferred and stored on servers and
                equipment located outside your country of residence. These servers and equipment may
                be owned and operated by third parties. Additionally, STREAMSIX and those third
                parties may further transfer, store, and process your personal information in other
                countries. It's important to be aware that the data protection laws of these
                countries may differ from those in your country of residence. By submitting your
                personal information through the Application, you consent to the transfer, storage,
                and processing of your personal information as described in this section. When
                participating in interactive games, services, or the downloading and uploading of
                content, STREAMSIX may collect, use, store, transmit, and publicly display
                statistical data regarding game play (including scores, rankings, and achievements),
                or identify content that you create and share with other players.
            </p>
            <p>
                <b>Your Choices and Controls</b>
            </p>
            <p>
                We provide you with choice and control about our use of your information, including
                your ability to exercise your data privacy rights.
            </p>
            <p>
                We give you meaningful choices when it comes to our collection and use of your
                information. For example, if you no longer want to receive marketing emails from
                STREAMSIX, you may click the unsubscribe link included in the footer of any
                marketing email we send.
            </p>
            <p>
                You can exercise any of your privacy rights by visiting our account console at  
                <span>https://auth.streamsix.com/auth</span>. To protect your account security and
                personal information, you may be asked to verify your account ownership. Once you
                have verified your account ownership, you may also be required to provide your
                confirmation authorizing an agent to exercise these rights on your behalf. If you
                have additional questions about exercising your privacy rights, you may contact us
                through <span>help@streamsix.com</span>. 
            </p>
            <p>
                Your right to deletion. You may delete your STREAMSIX Account and the personal
                information associated with your account through the account console at 
                <span>https://auth.streamsix.com/auth</span>. If you do so, you will no longer have
                access to the STREAMSIX games or Services associated with your account. Note that
                STREAMSIX may retain information needed to resolve disputes, enforce our user
                agreements, protect our legal rights, and comply with technical and legal
                requirements and constraints related to the security, integrity and operation of our
                Services. 
            </p>
            <p>
                Your right to access. You can access the personal information we hold about you
                please contact us using <span>help@streamsix.com</span> to request access to your
                personal  data, 
            </p>
            <p>
                Your right to correction. You can request correction of your personal information
                where it is inaccurate by emailing your request to help@streamsix.com
            </p>
            <p>
                Your right to opt out or object to certain processing. You may have the right to opt
                out of disclosing, sharing, or selling your personal information to third parties,
                if applicable, or object to some processing of your data, where such requests are
                permitted by law.
            </p>
            <p>
                Do Not Sell My Personal Information. You have the right to opt-out of selling your
                personal information to third parties. Once we receive and confirm a verifiable
                consumer request form from you, we will stop selling your personal information.
            </p>
            <p>
                To exercise your rights to opt-out, please contact us at 
                <span>help@streamsix.com</span>. 
            </p>
            <p>
                You also may adjust your browser settings to block certain online tracking
                technologies, such as cookies, as described in Section 2(A).
            </p>
            <p>
                You have a right not to receive discriminatory treatment for the exercise of these
                privacy rights.
            </p>
            <p>
                <br />
            </p>
            <p>
                <b>Third-Party Services</b>
            </p>
            <p>
                When using or accessing the Application through a social network or any other
                third-party platform, game console, app, or service (referred to as "Third Party
                Service"), it's possible that you'll need to have an account with the respective
                Third Party Service to either connect to the Application or to engage in certain
                transactions, including the STREAMSIX economy (see below). In such cases you will
                need to comply with the terms of use of the Third Party Service, in addition to our
                Terms.
            </p>
            <p>
                It's important to note that we are not responsible or liable for any actions,
                errors, or omissions of any Third Party Service. For all Third Party Services, you
                understand and agree that we do not assume responsibility or liability for: (i) the
                availability or accuracy of such websites or resources, or (ii) the content,
                products, or services offered on or through such websites or resources. The
                inclusion of links to these websites or resources does not imply our endorsement of
                their content, products, or services.
            </p>
            <p>
                You accept full responsibility and assume all associated risks when using any such
                websites or resources. It's essential to exercise caution and make informed
                decisions regarding their use.
            </p>
            <p>
                During your use of the Application, it's possible that you may communicate with,
                receive communications from, be redirected to, interact with, or engage in
                transactions with third parties such as our advertisers, sponsors, or promotional
                partners (referred to collectively as "Advertisers"). Please note that all such
                communication, interaction, and participation are solely between you and the
                Advertisers. We are not responsible or liable to you in any way for these activities
                or transactions, but reserve the right to report unauthorized access or
                communications from Advertisers. This includes any representations, warranties,
                covenants, contracts, or other terms and conditions that may exist between you and
                the Advertiser, as well as any goods or services you may purchase or obtain from
                them.
            </p>
            <p>
                <br />
            </p>
            <p>
                <b>General Health</b>
            </p>
            <p>
                <b>Seizure Warning: </b>We want to ensure the safety and well-being of all our
                users. It's important to note that a very small percentage of individuals may
                experience epileptic seizures when exposed to specific light patterns or flashing
                lights. These patterns or backgrounds can be encountered on mobile devices or while
                playing video games, and they have the potential to induce seizures in susceptible
                individuals.
            </p>
            <p>
                If you or anyone in your family has an epileptic condition, we strongly recommend
                consulting with your physician before engaging in any gaming activities. Your
                physician will be able to provide guidance and personalized advice based on your
                specific situation.
            </p>
            <p>
                While playing the Application, if you ever experience symptoms such as dizziness,
                altered vision, eye or muscle twitches, loss of awareness, disorientation, any
                involuntary movement, or convulsions, we urge you to immediately discontinue use and
                seek medical attention. Your health and well-being are our top priority, so it's
                essential to prioritize your safety.
            </p>
            <p>
                By taking the necessary precautions and being mindful of any potential risks, you
                can enjoy our Application with peace of mind
            </p>
            <p>
                <br />
            </p>
            <p>
                <b>STREAMSIX Privacy and Cookie Policy</b>
            </p>
            <p>
                Your privacy is important to STREAMSIX and we take our responsibility of caring for
                it seriously. You can find our Privacy Policy by following this link:
                https://www.streamsix.com/privacy-policy
            </p>
            <p>
                This policy describes, amongst other things, how we process the personal information
                we collect about you when you use our products and services or when you stream or
                play or view our games on our platform in connection with STREAMSIX.
            </p>
            <p>
                <br />
            </p>
            <p>
                <br />
            </p>
            <p>
                <b>STREAMSIX Community Standards and License</b>
            </p>
            <p>
                <b>Code of conduct</b> You can find our code of conduct by following this link:{' '}
                <span>Code of Conduct. </span>It outlines the guidelines and expectations we have
                for users of our Application. We encourage you to review it to ensure a positive and
                respectful experience for everyone.
            </p>
            <p>
                <br />
            </p>
            <p>
                <b>License and License Restrictions: </b>We are granting you a limited,
                non-exclusive, and revocable license to download, install, and use the Application
                and Application Content on your mobile device or any other compatible device.
                “Application Content” is defined as all the content included in the Application and
                games, such as textdesign, graphics, drawings, photographs, advertisements, video
                clips, music, sounds, trademarks, service marks, and trade names, This license is
                subject to your agreement to and continued compliance with these Terms.
            </p>
            <p>
                Please note that all intellectual property rights in and to the Application and the
                Application Content are expressly reserved to us or our licensors, unless expressly
                provided in these Terms. The Application is intended for personal use only. You are
                not granted a license to use, copy, distribute, sell, resell, republish, transmit,
                or exploit the Application or any Application Content for commercial purposes unless
                specified otherwise in these Terms or by first obtaining our prior written consent.
                We strictly prohibit any attempts to alter or interfere with the Application, such
                as translating, circumventing, modifying, disassembling, decompiling, reverse
                engineering, decrypting, or breaking its code.
            </p>
            <p>
                <br />
            </p>
            <p>
                However, if you are a streamer, you are allowed to freely use and distribute the
                Application on your personal website or on platforms meant for live streaming of
                games, where your viewers can freely access your content. You are also permitted to
                play the Application on lawful streaming platforms, such as Twitch, Kick, YouTube,
                and similar sites allowing you to share your gaming experiences with others.
            </p>
            <p>
                You may not develop, distribute, or use any third-party programs designed to give an
                unfair advantage in the Application, such as software bots, cheats, or hacks. You
                are fully liable for any unauthorized or authorized access to or use of the
                Application by third parties in violation of these Terms.
            </p>
            <p>
                To ensure the optimal performance and experience, the Application may automatically
                download and install updates, upgrades, and additional features that we consider
                reasonable, beneficial, or necessary. While we strive to provide support, we are not
                obligated to make previous versions of the Application available.
            </p>
            <p>
                We appreciate your understanding and adherence to these license terms and
                restrictions, as they are designed to protect the integrity of our community and
                ensure a fair and enjoyable experience for everyone.
            </p>
            <p>
                <br />
            </p>
            <p>
                <br />
            </p>
            <p>
                <b>The STREAMSIX Economy</b>
            </p>
            <p>
                <b>Fees and Payment: </b>In our Application and games, you may have the option to
                purchase virtual currency or assets from us through third-party stores. The fees for
                these purchases are clearly stated in the respective currency of the third-party
                stores. If there is a subscription fee structure, you have the flexibility to cancel
                monthly subscriptions at any time. If you cancel within 7 days of the start of a
                month, you will receive a full refund of the monthly fees. We will notify you of any
                price increases or changes to the subscription terms through various means,
                including messages within the Application.
            </p>
            <p>
                <br />
            </p>
            <p>
                When you make a purchase, you will be going through established services such as
                Apple App Store, Google Play, Steam, Xsolla or other platforms that we may introduce
                in the future. You agree to abide by their respective Terms and Conditions.
            </p>
            <p>
                <br />
            </p>
            <p>Please note that all sales are final.</p>
            <p>
                <br />
            </p>
            <p>
                <b>STREAMSIX Virtual Currencies:</b>
            </p>
            <p>We offer two different operating currencies within STREAMSIX.</p>
            <p>
                <br />
            </p>
            <p>
                <br />
            </p>
            <p>
                <b>STREAMGOLD:</b> STREAMGOLD is our currency primarily acquired through purchasing
                with fiat currency. You can use STREAMGOLD to tip, donate, or subscribe to your
                favorite streamers. Additionally, you can use STREAMGOLD to purchase premium virtual
                items in STREAMSIX authorized games, such as cosmetic rewards and consumables, for
                use in the Application or any approved game by STREAMSIX. You have the option to buy
                bundles of STREAMGOLD coins or subscribe monthly for them. You can transfer
                STREAMGOLD to other Eligible Members using the donate screen in the Application.
                There may be limits of the amount of STREAMGOLD that a member can donate per week.
                There are no fees charged for transfers, and once a transfer is made, it cannot be
                reversed. Please note that STREAMGOLD cannot be converted to fiat currency, holds no
                real-life value, does not earn interest, and is non-refundable.
            </p>
            <p>
                <br />
            </p>
            <p>
                <b>STREAMCASH:</b> STREAMCASH is our currency used for withdrawing funds to fiat
                currency or converting to other in-game hard currencies. If you are an Eligible
                Member, you can purchase STREAMCASH with STREAMGOLD. Once you have STREAMCASH, you
                can redeem it for fiat currency through the withdrawal process. The minimum
                withdrawal amount is USD$100 (or local equivalent), and withdrawals timing may be
                limited to once a week. There is a withdrawal processing fee payable to STREAMSIX
                and its third-party provider. Depending on the withdrawal amount, you may need to
                wait for a holding period of 45 days. Eligible Members have access to their
                STREAMCASH accounts, where they can view their activity and balances.
            </p>
            <p>
                <br />
            </p>
            <p>
                To be considered an "Eligible Member," you must comply with these Terms, be in good
                standing (abided by the Code of Conduct), and undergo a Know-Your-Customer (KYC)
                procedure conducted by our designated third-party payment solution provider before
                making a withdrawal. The eligibility criteria are determined by STREAMSIX and its
                third-party provider, and they hold the discretion to change them without prior
                notice.
            </p>
            <p>
                <br />
            </p>
            <p>
                Please be aware that you are not allowed to use or distribute STREAMGOLD, or
                STREAMCASH outside of the Application, except as expressly permitted by STREAMSIX.
                Any unauthorized use or attempted use of these currencies will be considered void
                and may result in the immediate termination of your account and your right to use
                STREAMSIX. We do not recognize or take responsibility for third-party services that
                facilitate the sale, transfer, or unauthorized use of STREAMCASH. Any such use by
                another user would be a violation of these Terms.
            </p>
            <p>
                <br />
            </p>
            <p>
                <br />
            </p>
            <p>
                <b>User Generated Content (UGC)</b>
            </p>
            <p>
                The Application provides you with the ability to upload various forms of content
                directly, including statuses, links, images, comments, and conversations, referred
                to as “User Generated Content” or "UGC." By uploading UGC to the Application, you
                affirm, represent, and warrant that you possess all the necessary rights, titles,
                and interests in your UGC, and that it is accurate and reliable.
            </p>
            <p>
                You are responsible for any damages or losses incurred by us due to copyright
                infringement resulting from your UGC, including payment of damages and statutory
                damages arising from contributory or direct infringement, even if the content was
                edited and republished by us. We reserve the right to remove any UGC if we
                reasonably determine that it infringes upon the intellectual property rights of any
                third party.
            </p>
            <p>
                Additionally, we reserve the right to edit your content as we deem appropriate. If
                we reasonably determine that you are a repeat infringer, we reserve the right to
                terminate your access to the Application.
            </p>
            <p>
                You acknowledge that, unless explicitly and in writing agreed otherwise between us,
                you won’t receive any compensation, payment, or interests for uploading your UGC.
                You agree to allow other users of the Application to freely access your UGC and
                "follow" your profile without any compensation on their behalf.
            </p>
            <p>
                By uploading your UGC, you grant us a worldwide, non-revocable, royalty-free,
                sublicensable, and transferable license to use your UGC, including copyrighted
                works, trade secrets, ideas, inventions, utility models, designs, patents, software,
                and other intellectual property, in any way we see fit at our sole discretion. This
                includes reproduction, distribution, creation of derivatives, modification,
                adaptation, publication, translation, and display. For clarity, we may include your
                UGC in our outgoing feed to third parties, who may publish the feed (including your
                UGC) outside of the Application.
            </p>
            <p>
                You and any third party under your account are prohibited from uploading, streaming,
                sharing, presenting, or disseminating UGC that: encourages acts of violence,
                infringes upon third parties' intellectual property rights, contains spam or chain
                mail, violates third parties' right to privacy or publicity rights, contains
                confidential or proprietary information, is defamatory, fraudulent, libelous,
                abusive, obscene, unlawful, threatening, hateful, harassing, racially offensive,
                sexist, or otherwise inappropriate by reasonable standards, advertises or solicits
                third parties' business, or contains any form of malware or interferes with the
                service in any way.
            </p>
            <p>
                We do not guarantee and have no obligation to post, transmit, distribute, upload,
                publish, or display any UGC and may refuse to do so at our sole discretion.
            </p>
            <p>
                <br />
            </p>
            <p>
                <b>User and Creator Disputes</b>
            </p>
            <p>
                <b></b>
                <br />
            </p>
            <p>
                <b>Disputes Between Users and Creators</b>: We believe in fostering a positive and
                collaborative environment for our users and creators. If you, as a user, have any
                concerns or issues with any user-generated content (UGC) created by creators,
                whether it's within the Application or shared via a third-party platform, we
                encourage you to first reach out directly to the creator involved. Open
                communication can often lead to a swift resolution and a better understanding
                between both parties.
            </p>
            <p>
                <br />
            </p>
            <p>
                <b>User-to-User Copyright Complaint Process:</b> At STREAMSIX, we take intellectual
                property rights seriously and encourage originality within our community. Copying
                another user's UGC and passing it off as your own is strictly prohibited. If you
                believe that another user or creator has improperly copied original material you
                previously uploaded to STREAMSIX, violating our Terms, we have a complaint process
                (“Complaint Process”) to address such concerns. To file a complaint, please email{' '}
                <span>help@streamsix.com </span>and provide details, including the copied material,
                your original work, and any relevant information. Our team will conduct a thorough
                investigation into the matter and determine if a violation of our Terms has
                occurred. If a violation is confirmed, appropriate actions will be taken, which may
                include removing the copied material or even terminating the user's account,
                depending on the severity of the offense.
            </p>
            <p>
                <br />
            </p>
            <p>
                <b>Escalation to STREAMSIX:</b> While it's important to note that STREAMSIX is not
                directly responsible for disputes between users and creators, we genuinely care
                about your experience on our platform and want to ensure everyone's satisfaction. As
                such, we have the right (but not the obligation) to step in and mediate these
                issues, aiming to find a fair resolution for all parties involved.
            </p>
            <p>
                Before escalating any concerns to STREAMSIX, we kindly request that you make a
                sincere effort to resolve the matter with the creator. Building constructive
                dialogue and working towards a solution together is always the best approach.
                However, if your efforts do not yield a satisfactory outcome, you can reach out to
                our dedicated Customer Service team by emailing <span>help@streamsix.com </span> .We
                are here to assist you and will do our best to help address your concerns.
            </p>
            <p>
                In cases where STREAMSIX intervenes in a dispute between a user and a creator, we
                want to assure you that our decision will be carefully considered. This decision may
                involve actions such as deducting currency from the creator's account and crediting
                currency to the user's account, if deemed appropriate. We ask that both the user and
                creator accept and respect the final decision made by STREAMSIX. Timely cooperation
                from all parties involved is essential in resolving such matters, and failure to do
                so would be a violation of these Terms.
            </p>
            <p>
                If you disagree with our determination, Simply send an email to{' '}
                <span>help@streamsix.com </span>to initiate the process. It's important to note that
                any decision made by STREAMSIX on an appeal is final and binding.
            </p>
            <p>
                To ensure a streamlined and fair complaint resolution process, we require users or
                creators who believe their UGC has been improperly copied to use our Complaint
                Process outlined above exclusively. This means that any form of harassment or filing
                complaints with external entities regarding UGC copied on our services is
                prohibited. Please note that corporate entities, while not required, may also
                utilize the Complaint Process.
            </p>
            <p>
                <br />
            </p>
            <p>
                <br />
            </p>
            <p>Now here comes some importation legal information that you need to be aware of:</p>
            <ul>
                <li>
                    <b></b>
                    <span>
                        <b>Disclaimers.</b>
                    </span>{' '}
                    THE APPLICATION AND APPLICATION CONTENT IS PROVIDED “AS IS” AND “AS AVAILABLE”
                    BASIS WITHOUT ANY REPRESENTATIONS, CONDITIONS, WARRANTIES OR OTHER TERMS OF ANY
                    KIND. TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, STREAMSIX DISCLAIMS ALL
                    REPRESENTATIONS, WARRANTIES, CONDITIONS AND OTHER TERMS, EXPRESS OR IMPLIED
                    (INCLUDING WITHOUT LIMITATION ANY IMPLIED WARRANTIES OR CONDITIONS OF
                    MERCHANTABLE QUALITY, MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
                    NON-INFRINGEMENT), INCLUDING THOSE ARISING BY STATUE OR OTHERWISE IN LAW OR FROM
                    A COURSE OF DEALING OR USAGE OF TRADE. STREAMSIX does not warrant that the
                    Application or Application Content will meet your requirements. STREAMSIX does
                    not represent, warrant, or covenant that the Application will be available,
                    uninterrupted, timely, secure, or error free. STREAMSIX does not warrant,
                    guarantee, or make any representations regarding the use or the results of the
                    use of the Application with respect to performance, accuracy, reliability,
                    security capability, currency or otherwise. STREAMSIX does not guarantee the
                    accuracy of any Application Content, statistical data regarding game play, or
                    other information displayed by the Application. STREAMSIX does not guarantee the
                    accuracy or availability of offers, advertisements, promotions, or prices
                    displayed through the Application or as part of the Application Content.
                    STREAMSIX is not responsible for any problems or technical malfunction of any
                    telephone network or lines, computer online systems, servers or providers,
                    computer equipment, wifi services, cellular services, software, failure of email
                    or players on account of technical problems or traffic congestion on the
                    internet or at any website or combination thereof, including injury or damage to
                    users or to any other person’s computer related to or resulting from
                    participating or downloading the Application. Under no circumstances will we or
                    any of our affiliates, advertisers, promoters or distribution partners be
                    responsible for any loss or damage, including personal injury or death,
                    resulting from anyone’s use of the Application.
                </li>
            </ul>
            <p>
                <br />
            </p>
            <p>
                <br />
            </p>
            <ul>
                <li>
                    <b></b>
                    <span>
                        <b>Limitation of Liability</b>
                    </span>
                    . YOU ACKNOWLEDGE THAT YOUR USE OF THE APPLICATION IS AT YOUR SOLE RISK. TO THE
                    FULLEST EXTENT PERMITTED UNDER APPLICABLE LAW, IN NO EVENT WILL STREAMSIX OR ITS
                    OFFICERS, DIRECTORS, EMPLOYEES, AFFILIATES, AGENTS, LICENSORS, ADVERTISERS,
                    PROMOTERS OR DISTRIBUTION PARTNERS, BE LIABLE FOR ANY INDIRECT, INCIDENTAL,
                    SPECIAL, PUNITIVE, CONSEQUENTIAL OR EXEMPLARY DAMAGES, INCLUDING, BUT NOT
                    LIMITED TO, DAMAGES FOR LOSS OF REVENUES, PROFITS, GOODWILL, USE, DATA OR OTHER
                    INTANGIBLE LOSSES (EVEN IF SUCH PARTIES WERE ADVISED OF THE POSSIBILITY OF SUCH
                    DAMAGES), ARISING OUT OF OR RELATED TO YOUR USE OF THE APPLICATION OR
                    APPLICATION CONTENT, REGARDLESS OF WHETHER SUCH DAMAGES ARE BASED ON CONTRACT,
                    TORT (INCLUDING NEGLIGENCE, GROSS NEGLIGENCE AND STRICT LIABILITY), WARRANTY,
                    STATUTE OR OTHERWISE, INCLUDING BUT NOT LIMITED TO LOSS OR DAMAGE DUE TO VIRUSES
                    THAT MAY AFFECT YOUR COMPUTER EQUIPMENT, SOFTWARE, DATA OR OTHER PROPERTY ON
                    ACCOUNT OF YOUR ACCESS TO, USE OF THE APPLICATION OR YOUR DOWNLOADING OF ANY
                    MATERIAL WHILE USING THE APPLICATION. THE FOREGOING LIMITATIONS SHALL APPLY TO
                    THE MAXIMUM EXTENT PERMITTED BY LAW, EVEN IF ANY REMEDY FAILS OF ITS ESSENTIAL
                    PURPOSE. IN NO EVENT SHALL STREAMSIX’S OR ITS OFFICERS, DIRECTORS, EMPLOYEES,
                    AFFILIATES, AGENTS, LICENSORS, ADVERTISERS, PROMOTERS OR DISTRIBUTION PARTNERS’
                    AGGREGATE LIABILITY, WHETHER ARISING IN CONTRACT, TORT, STRICT LIABILITY OR
                    OTHERWISE, EXCEED THE GREATER OF (I) THE TOTAL FEES PAID BY YOU TO STREAMSIX
                    DURING THE ONE (1) MONTH IMMEDIATELY PRIOR TO THE TIME SUCH CLAIM AROSE; (II)
                    ONE HUNDRED DOLLARS ($100.00).
                </li>
            </ul>
            <p>
                <br />
            </p>
            <ul>
                <li>
                    <b></b>
                    <span>
                        <b>Governing Law</b>
                    </span>
                    . These Terms are governed by and will be construed in accordance with the laws
                    of the Province of Ontario and the laws of Canada applicable therein. Any legal
                    action or proceeding relating to your access to, or use of, the Application or
                    these Terms, shall be resolved by arbitration pursuant to the general Canadian
                    Arbitration Association Rules for Arbitration. Either party may serve notice of
                    its desire to refer a dispute to arbitration. The arbitration shall be conducted
                    by a single arbitrator, and the arbitration shall be held in Toronto, Canada.
                    The decision arrived at by the arbitrator shall be final and binding and no
                    appeal shall be permitted. Judgment upon the award rendered by the arbitrator
                    may be entered in any court having jurisdiction. The costs of the arbitrator
                    shall be divided equally between the parties. You agreed that you may bring
                    claims against STREAMSIX only in your individual capacity and not as a plaintiff
                    or class member in any purported class or representative proceeding.
                </li>
                <li>
                    <b></b>
                    <span>
                        <b>Remedies</b>
                    </span>
                    . You acknowledge that STREAMSIX may suffer irreparable damage if you breach any
                    of these Terms. You therefore agree that if you do breach such provisions, in
                    addition to provable damages and reasonable attorneys’ fees, STREAMSIX shall be
                    entitled to enjoin such breach and to obtain specific performance of such
                    provisions in any court of competent jurisdiction.
                </li>
            </ul>
            <p>
                <br />
            </p>
            <ul>
                <li>
                    <b></b>
                    <span>
                        <b>Indemnification</b>
                    </span>
                    . You agree to defend, indemnify and hold harmless STREAMSIX, its officers,
                    directors, employees, affiliates, agents, licensors, advertisers, promoters and
                    distribution partners, from all claims, liabilities, and expenses, including
                    attorneys’ fees, arising from or relating to your use or misuse of, or access
                    to, the Application, or user content/UGC, violation of these Terms, or
                    infringement by you, or any third party using your account, of any intellectual
                    property or other right of any person or entity. STREAMSIX reserves the right to
                    assume the exclusive defense and control of any claim otherwise subject to
                    indemnification by you.
                </li>
            </ul>
            <p>
                <br />
            </p>
            <p>
                <br />
            </p>
            <ul>
                <li>
                    <b></b>
                    <span>
                        <b>Miscellaneous</b>
                    </span>
                    . You may not assign these Terms, in whole or in part, without STREAMSIX’S prior
                    written consent and any attempted assignment in violation of this provision
                    shall be null and void. The delay or omission by either party to enforce or
                    exercise any terms or right pursuant to these Terms will not impair any such
                    term or right nor be construed to be a waiver thereof and will in no way affect
                    the other party’s right later to enforce it. Any waiver by either party of any
                    covenants, conditions or agreements to be performed by the other party will not
                    be construed to be a waiver of any succeeding breach thereof or any covenant,
                    conditions or agreement herein contained, whether similar or otherwise. If any
                    part of these Terms is unlawful, void, or unenforceable, that part will be
                    deemed severable and will not affect the validity or enforceability of any
                    remaining provisions. Any information related to your use of the Application for
                    illegal purposes will be provided to law enforcement authorities. These Terms
                    constitute the entire agreement between the parties relating to the use of the
                    Application and supersedes and replaces any prior agreement and communication
                    between the parties relating thereto. All questions concerning these Terms shall
                    be directed to: STREAMSIX Inc., 49 Bathurst Street, Suite 400, Toronto, ON M5V
                    2P2, Attention: Legal Department. STREAMSIX is a trademark of STREAMSIX Inc.
                </li>
            </ul>
        </Flex>
    );

    return (
        <>
            <BrowserView>
                <BrowserTopBar color="#FFF" isLoading={false}>
                    <Box className={'settings-title browser-view-title'}>
                        <Text>TERMS AND CONDITIONS</Text>
                    </Box>
                </BrowserTopBar>
                <BrowserSidebar />
                <Flex className={'browser-content'}>{renderContent()}</Flex>
            </BrowserView>
            <MobileViewPage
                title="TERMS AND CONDITIONS"
                titleColor="#FFF"
                titleBackgroundColor="#6867dd"
                isLoading={false}
            >
                <Flex className={'privacy-mobile'}>{renderContent()}</Flex>
            </MobileViewPage>
        </>
    );
};
